import {
  Banner,
  Box,
  FormField,
  FormGrid,
  ModalBody,
  ModalFoot,
  Text,
} from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import { HolidayCalendarSelector } from 'components/settings/components/sections/openingHours/components/holidayCalendarSelector/holidayCalendarSelector';

import { useMigrateOpeningHoursContext } from '../../migrateOpeningHours.context';

export function Holidays(): JSX.Element {
  const {
    setters: { setHolidays },
    onCancel,
    onNextStep,
  } = useMigrateOpeningHoursContext();

  const handleHolidayChange = useCallback(
    (countryCode: string | null, isClosedOnHolidays: boolean) =>
      setHolidays(countryCode ? { countryCode, isClosedOnHolidays } : null),
    [setHolidays],
  );

  return (
    <>
      <ModalBody>
        <Text.Paragraph subdued variant="2">
          Connect holiday calendars with your schedules to adjust your business
          hours on those days. Later on, you can also create custom exceptions,
          e.g. Black Friday.
        </Text.Paragraph>
        <Box margin="400 0">
          <Banner
            icon="calendar"
            variant="announcement"
            description={
              <Text.Paragraph variant="4">
                We automatically update your holiday dates and business hours
                every year, so you can spend your time more wisely!
              </Text.Paragraph>
            }
          />
        </Box>
        <FormGrid>
          <FormField>
            <HolidayCalendarSelector onChange={handleHolidayChange} clearable />
          </FormField>
        </FormGrid>
      </ModalBody>
      <ModalFoot
        cancelOnClick={onCancel}
        confirmName="Continue to audio message"
        confirmOnClick={onNextStep}
      />
    </>
  );
}
